// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3Lt8w","unreadBadge":"styles_unreadBadge__3ng5c","modalContent":"styles_modalContent__3zCFB","modal":"styles_modal__1vWGW"};